import { ActionCreators } from 'exchange-common'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

export const OrderbooksMain = () => {
	const dispatch = useDispatch()
	const markets = useSelector((state: IState) => state.markets.list)
	const symbol = useSelector((state: IState) => state.markets.current)
	const orderbook = useSelector((state: IState) => state.orderbook)
	const market = markets[symbol]
	useEffect(() => {
		if (!Object.keys(markets).length) {
			ws.send(ActionCreators.Market.getList())
		}
		if (!orderbook.isLoaded) {
			ws.send(ActionCreators.Subscribe.orderbook(symbol))
		}
	}, [])

	if (!symbol || !market) {
		return <div />
	}

	const changeMarket = (event: React.ChangeEvent<HTMLSelectElement>) => {
		ws.send(ActionCreators.Unsubscribe.orderbook(symbol))
		dispatch(ActionCreators.Market.change(event.target.value))
		ws.send(ActionCreators.Subscribe.orderbook(event.target.value))
	}

	const cancelOrder = (orderId: number) => {
		const confirmed = confirm(`do you really want to cancel orderId ${orderId}?`)
		if (!confirmed) {
			return
		}
		const cancelAction: any = { type: 'Order.CancelAdmin', order: { orderId } }
		ws.send(cancelAction)
	}

	const cancelAll = () => {
		const confirmed = confirm(`do you really want to cancel all open orders?`)
		if (!confirmed) {
			return
		}
		const cancelAllAction: any = { type: 'Order.CancelAllAdmin', symbol }
		ws.send(cancelAllAction)
	}

	const toggleTrade = () => {
		if (confirm('Are you sure?')) {
			ws.send(ActionCreators.Market.update({
				marketId: market.marketId,
				canTrade: !market.canTrade,
			}))
		}
	}
	const toggleVisible = () => {
		if (confirm('Are you sure?')) {
			if (market.canTrade && market.visible) {
				alert('ATENTION: you still can trade on this market!')
			}
			ws.send(ActionCreators.Market.update({
				marketId: market.marketId,
				visible: !market.visible,
			}))
		}
	}

	return (
		<div className='orderbooksMain'>
			<span className='pageTitle'>Orderbooks</span>
			<span className='pageBoxTitle'>Market:
				<select onChange={changeMarket}>
					{Object.keys(markets).map(m => (
						<option value={m} selected={m === symbol}>{m}</option>
					))
					}
				</select></span>
			<br />
			<div>
				<table className='walletsTableMain'>
					<thead>
						<tr className='walletsTableHeaderRow'>
							<td className='walletsTableHeaderRowItem'>Trade Status</td>
							<td className='walletsTableHeaderRowItem'>Trade Action</td>
							<td className='walletsTableHeaderRowItem'>Clear Orders</td>
							<td className='walletsTableHeaderRowItem'>Visible Status</td>
							<td className='walletsTableHeaderRowItem'>Visible Action</td>
						</tr>
					</thead>
					<tbody>
						<tr className='walletsTableBodyRow'>
							<td className='walletsTableBodyRowItem'><span className={market.canTrade ? 'green' : 'red'}><b>{market.canTrade ? 'Enabled' : 'Disabled'}</b></span></td>
							<td className='walletsTableBodyRowItem'><button className='walletsTableButton' onClick={toggleTrade}>{market.canTrade ? 'Turn Off' : 'Turn On'}</button></td>
							<td className='walletsTableBodyRowItem'><button className='walletsTableButton red' onClick={cancelAll}>Cancel All</button></td>
							<td className='walletsTableBodyRowItem'><span className={market.visible ? 'green' : 'red'}><b>{market.visible ? 'Enabled' : 'Disabled'}</b></span></td>
							<td className='walletsTableBodyRowItem'><button className='walletsTableButton' onClick={toggleVisible}>{market.visible ? 'Turn Off' : 'Turn On'}</button></td>
						</tr>
					</tbody>
				</table>
			</div>
			<br />
			<div className='orderbooksFlex'>
				<div className='orderbooksHalf'>
					<span className='pageBoxTitle'>Buy Orders</span>
					<div>
						<table className='withdrawsTableMain'>
							<thead>
								<tr className='withdrawsTableHeaderRow'>
									<td className='withdrawsTableHeaderRowItem'>Action</td>
									<td className='withdrawsTableHeaderRowItem'>UserId</td>
									<td className='withdrawsTableHeaderRowItem'>Price (BTC)</td>
									<td className='withdrawsTableHeaderRowItem'>Market Size (LTC)</td>
								</tr>
							</thead>
							<tbody>
								{orderbook.bids.map(m => (
									<tr className='withdrawsTableBodyRow' key={m.orderId}>
										<td className='ordersTableBodyRowItem'><span className='ordersCancelOrder pointer' onClick={() => cancelOrder(m.orderId)}>Cancel</span></td>
										<td className='withdrawsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.userId), 6)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.price.toFixed(market.priceDecimals)}</td>
										<td className='withdrawsTableBodyRowItem'>{(m.amount - m.filled).toFixed(market.amountDecimals)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div className='orderbooksHalf'>
					<span className='pageBoxTitle'>Sell Orders</span>
					<div>
						<table className='withdrawsTableMain'>
							<thead>
								<tr className='withdrawsTableHeaderRow'>
									<td className='withdrawsTableHeaderRowItem'>Market Size (LTC)</td>
									<td className='withdrawsTableHeaderRowItem'>Price (BTC)</td>
									<td className='withdrawsTableHeaderRowItem'>UserId</td>
									<td className='withdrawsTableHeaderRowItem'>Action</td>
								</tr>
							</thead>
							<tbody>
								{orderbook.asks.map(m => (
									<tr className='withdrawsTableBodyRow' key={m.orderId}>
										<td className='withdrawsTableBodyRowItem'>{(m.amount - m.filled).toFixed(market.amountDecimals)}</td>
										<td className='withdrawsTableBodyRowItem'>{m.price.toFixed(market.priceDecimals)}</td>
										<td className='withdrawsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(m.userId), 6)}</td>
										<td className='ordersTableBodyRowItem'><span className='ordersCancelOrder pointer' onClick={() => cancelOrder(m.orderId)}>Cancel</span></td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/orderbooksMain.tsx